import { useQuery } from '@tanstack/react-query'
import { FillRateMetrics, getFillRateMetrics } from 'api/pulse/fillRateMetrics'
import { PulseFilters } from 'api/pulse'
import { getFillRateMetricsKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useFillRateMetrics(query: PulseFilters) {
  return useQuery<FillRateMetrics>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getFillRateMetricsKey(query),
    queryFn: ({ signal }) => getFillRateMetrics(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
